// 漫画岛 - 站点信息
export const SITE_INFO = {
  name: "漫画岛",
  enName: "Comic Island",
  slogan: "看完漫画来聊剧情，找同好一起追更",
  description:
    "漫画岛是一个面向漫画爱好者的同好讨论社区，聚合漫画评论区、粉丝圈子与书评交流。这里有热门漫画安利、深度书评、追更讨论与推荐互助，让你看完漫画随时聊剧情、求推荐、找同好一起追更。",
  domain: "https://comixn.github.io",
  contact: "hello@comicisland.cn",
  phone: "400-880-1234",
  address: "上海市徐汇区漫画路 88 号动漫产业园区 3 号楼",
  founded: 2019,
  members: "86万",
  articles: "12,000+",
  categories: "6 大类型",
  faqSummary: [
    "评论交流、书评推荐、粉丝圈子、追更互助",
    "热血冒险、恋爱日常、玄幻仙侠、悬疑烧脑、搞笑治愈、科幻未来",
    "安利墙随时互动，看完漫画来聊剧情求推荐",
  ],
};

// 分类
export type ComicCategory = {
  id: string;
  name: string;
  enName: string;
  desc: string;
  icon: string;
  count: number;
};

export const categories: ComicCategory[] = [
  { id: "reqiu", name: "热血冒险", enName: "Adventure", desc: "燃到极致的战斗与成长，少年心气一往无前", icon: "ri-fire-line", count: 248 },
  { id: "lianai", name: "恋爱日常", enName: "Romance", desc: "甜甜的校园与都市恋情，心动与治愈并存", icon: "ri-heart-3-line", count: 315 },
  { id: "xuanhuan", name: "玄幻仙侠", enName: "Fantasy", desc: "仙途问道、御剑江湖，东方幻想魅力无穷", icon: "ri-sword-line", count: 287 },
  { id: "xuanyi", name: "悬疑烧脑", enName: "Mystery", desc: "迷雾重重、反转不断，真相藏在细节里", icon: "ri-magic-line", count: 176 },
  { id: "gaoxiao", name: "搞笑治愈", enName: "Comedy", desc: "捧腹大笑与暖心治愈，给生活加点甜", icon: "ri-emotion-happy-line", count: 203 },
  { id: "kehuan", name: "科幻未来", enName: "Sci-Fi", desc: "机甲星河、时间旅行，脑洞大开的未来世界", icon: "ri-rocket-2-line", count: 159 },
];

// 漫画
export type Comic = {
  id: string;
  title: string;
  categoryId: string;
  author: string;
  cover: string;
  rating: number;
  status: string;
  tags: string[];
  views: number;
  chapters: number;
  latestChapter: string;
  updateTime: string;
  intro: string;
};

export const comics: Comic[] = [
  {
    id: "c-reqiu-01", title: "炎拳物语", categoryId: "reqiu", author: "星野燎原", rating: 9.4,
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20determined%20young%20fire%20hero%20wielding%20a%20flaming%20fist%2C%20orange%20and%20crimson%20tones%2C%20dynamic%20action%20pose%2C%20simple%20warm%20gradient%20background%2C%20vibrant%20comic%20art%2C%20high%20detail&width=480&height=640&seq=cover-reqiu-01&orientation=portrait",
    status: "连载中", tags: ["战斗", "成长", "燃向"], views: 128000, chapters: 168, latestChapter: "第168话 · 涅槃", updateTime: "今日更新", intro: "少年炎枫背负灭族之仇，掌握禁忌之火的力量，在复仇与守护之间抉择。燃点密集、打斗热血，每一次觉醒都令人血脉偾张。",
  },
  {
    id: "c-reqiu-02", title: "航海狂潮", categoryId: "reqiu", author: "浪里白条", rating: 9.1,
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20young%20pirate%20captain%20standing%20on%20a%20ship%20deck%20with%20a%20rising%20sun%2C%20ocean%20adventure%2C%20warm%20golden%20tones%2C%20simple%20background%2C%20vibrant%20comic%20art&width=480&height=640&seq=cover-reqiu-02&orientation=portrait",
    status: "连载中", tags: ["冒险", "海洋", "群像"], views: 96400, chapters: 142, latestChapter: "第142话 · 风暴之眼", updateTime: "昨日更新", intro: "少年诺亚立志成为最伟大的航海王，和伙伴们扬帆穿越七大海洋，寻找传说中的「大秘宝」。友情、勇气与梦想交织的热血群像剧。",
  },
  {
    id: "c-reqiu-03", title: "幻影忍者传", categoryId: "reqiu", author: "影之刃", rating: 8.8,
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20shadow%20ninja%20in%20a%20dynamic%20leaping%20pose%2C%20warm%20twilight%20sky%2C%20red%20and%20gold%20tones%2C%20action%20comic%20art&width=480&height=640&seq=cover-reqiu-03&orientation=portrait",
    status: "连载中", tags: ["忍者", "格斗", "暗影"], views: 71200, chapters: 96, latestChapter: "第96话 · 影之传承", updateTime: "3天前更新", intro: "落选忍者学院的少年影，意外觉醒传说中的幻影之力，从此踏上成为最强忍者的道路。隐忍与爆发之间，写尽热血男儿的成长。",
  },
  {
    id: "c-reqiu-04", title: "武道巅峰", categoryId: "reqiu", author: "无影腿", rating: 8.6,
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20martial%20arts%20master%20performing%20a%20mid-air%20kick%2C%20warm%20dojo%20background%2C%20red%20and%20gold%20tones%2C%20dynamic%20composition%2C%20vibrant%20comic%20art&width=480&height=640&seq=cover-reqiu-04&orientation=portrait",
    status: "已完结", tags: ["武侠", "宗师", "武道"], views: 58600, chapters: 210, latestChapter: "已完结", updateTime: "完结", intro: "天资平平的少年林动，凭一股不服输的狠劲，在武道一途逆天改命。拳拳到肉的打斗、层层递进的境界突破，堪称热血武侠经典。",
  },
  {
    id: "c-lianai-01", title: "樱花恋语", categoryId: "lianai", author: "四月岚", rating: 9.3,
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20shy%20high%20school%20girl%20standing%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20and%20warm%20tones%2C%20gentle%20romantic%20mood%2C%20simple%20background%2C%20anime%20art&width=480&height=640&seq=cover-lianai-01&orientation=portrait",
    status: "连载中", tags: ["校园", "纯爱", "青春"], views: 112000, chapters: 88, latestChapter: "第88话 · 花期", updateTime: "今日更新", intro: "转学生苏樱在樱花纷飞的季节遇见了青梅竹马的陆沉，一段跨越十年的暗恋缓缓展开。画风唯美、情感细腻，每格都是青春心动的模样。",
  },
  {
    id: "c-lianai-02", title: "同桌的心事", categoryId: "lianai", author: "糖分超标", rating: 8.9,
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20two%20high%20school%20classmates%20sitting%20at%20a%20desk%2C%20warm%20classroom%20light%2C%20romantic%20slice%20of%20life%2C%20soft%20warm%20tones%2C%20anime%20art&width=480&height=640&seq=cover-lianai-02&orientation=portrait",
    status: "连载中", tags: ["校园", "日常", "甜宠"], views: 88400, chapters: 120, latestChapter: "第120话 · 悄悄话", updateTime: "昨日更新", intro: "一个关于同桌之间小心思的治愈日常。成绩垫底的学渣和冰山学霸成为同桌，从互不顺眼到暗生情愫，每一话都甜度爆表。",
  },
  {
    id: "c-lianai-03", title: "春日烘焙屋", categoryId: "lianai", author: "奶盖阿噗", rating: 8.7,
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20cheerful%20baker%20girl%20holding%20croissants%20in%20a%20warm%20bakery%2C%20golden%20morning%20light%2C%20cozy%20warm%20tones%2C%20anime%20art&width=480&height=640&seq=cover-lianai-03&orientation=portrait",
    status: "连载中", tags: ["美食", "职场", "治愈"], views: 65700, chapters: 76, latestChapter: "第76话 · 新品上架", updateTime: "4天前更新", intro: "辞职回乡开烘焙屋的女孩林小满，用一块块甜品治愈客人的故事。面包的香气与初恋的心跳交织，暖到胃也暖到心。",
  },
  {
    id: "c-lianai-04", title: "月光信笺", categoryId: "lianai", author: "银时予你", rating: 8.5,
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20girl%20writing%20a%20letter%20by%20moonlight%20at%20a%20window%2C%20romantic%20warm%20night%20tones%2C%20anime%20art&width=480&height=640&seq=cover-lianai-04&orientation=portrait",
    status: "已完结", tags: ["书信", "暗恋", "双向奔赴"], views: 52100, chapters: 60, latestChapter: "已完结", updateTime: "完结", intro: "在手机盛行的年代，两个笔友坚持用书信互通心意。月光下的信笺，承载着最纯粹也最炽热的暗恋，最后等来双向奔赴的圆满。",
  },
  {
    id: "c-xuanhuan-01", title: "九霄仙途", categoryId: "xuanhuan", author: "御剑清霜", rating: 9.5,
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20an%20immortal%20swordsman%20flying%20with%20a%20glowing%20sword%20among%20clouds%20and%20mountains%2C%20xianxia%20fantasy%2C%20warm%20gold%20and%20jade%20tones%2C%20epic%2C%20comic%20art&width=480&height=640&seq=cover-xuanhuan-01&orientation=portrait",
    status: "连载中", tags: ["修仙", "御剑", "东方幻想"], views: 156000, chapters: 240, latestChapter: "第240话 · 飞升", updateTime: "今日更新", intro: "一介凡尘少年偶然拾得仙剑，踏上九霄问道之路。修炼体系严谨、打斗飘逸大气，东方仙侠韵味十足，是当下最火的热门玄幻漫画。",
  },
  {
    id: "c-xuanhuan-02", title: "炼药大厨", categoryId: "xuanhuan", author: "一口仙丹", rating: 8.8,
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20an%20alchemist%20cooking%20with%20a%20glowing%20cauldron%2C%20herbs%20and%20steam%2C%20warm%20fantasy%20tones%2C%20xianxia%20comic%20art&width=480&height=640&seq=cover-xuanhuan-02&orientation=portrait",
    status: "连载中", tags: ["炼丹", "搞笑", "美食"], views: 73400, chapters: 154, latestChapter: "第154话 · 药香四溢", updateTime: "2天前更新", intro: "废柴厨子意外穿越修仙界，把炼丹玩成了炒菜。药香四溢、笑料百出，用一口大铁锅炼出无数天材地宝，逆袭之路又香又好玩。",
  },
  {
    id: "c-xuanhuan-03", title: "镇魔令", categoryId: "xuanhuan", author: "玄墨", rating: 8.4,
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20young%20exorcist%20holding%20a%20talisman%20scroll%20with%20glowing%20seals%2C%20warm%20mystic%20tones%2C%20fantasy%20comic%20art&width=480&height=640&seq=cover-xuanhuan-03&orientation=portrait",
    status: "连载中", tags: ["除妖", "符箓", "暗黑"], views: 48900, chapters: 88, latestChapter: "第88话 · 镇魔台", updateTime: "5天前更新", intro: "镇魔司最年轻的执令者玄夜，游走于人间与妖界之间。符箓翻飞、妖气纵横，在一次次除魔中揭开身世之谜，暗黑风格张力十足。",
  },
  {
    id: "c-xuanyi-01", title: "雾都侦探", categoryId: "xuanyi", author: "烟雨迷离", rating: 9.2,
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20trench%20coat%20detective%20standing%20under%20a%20street%20lamp%20in%20fog%2C%20mystery%20noir%20mood%2C%20warm%20amber%20and%20brown%20tones%2C%20comic%20art&width=480&height=640&seq=cover-xuanyi-01&orientation=portrait",
    status: "连载中", tags: ["推理", "刑侦", "迷雾"], views: 82400, chapters: 132, latestChapter: "第132话 · 迷雾深处", updateTime: "昨日更新", intro: "常年笼罩在雾中的城市发生连环案件，落魄侦探老徐与天才助手小棠联手破案。线索环环相扣、反转出人意料，烧脑程度拉满。",
  },
  {
    id: "c-xuanyi-02", title: "谜案第十夜", categoryId: "xuanyi", author: "夜行者", rating: 8.7,
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20locked%20room%20with%20a%20magnifying%20glass%20and%20scattered%20clues%2C%20warm%20dim%20lighting%2C%20suspenseful%20mystery%2C%20comic%20art&width=480&height=640&seq=cover-xuanyi-02&orientation=portrait",
    status: "连载中", tags: ["密室", "悬疑", "推理"], views: 53800, chapters: 64, latestChapter: "第64话 · 第十夜", updateTime: "3天前更新", intro: "每一夜都有一桩离奇命案，唯有第十夜才能窥见真相。密室诡计、时间谜题层层嵌套，读者与主角一同解谜，代入感极强。",
  },
  {
    id: "c-xuanyi-03", title: "时间缝隙", categoryId: "xuanyi", author: "异时空旅人", rating: 8.3,
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20clock%20splitting%20reality%20with%20a%20silhouette%2C%20warm%20surreal%20tones%2C%20time%20mystery%20concept%2C%20comic%20art&width=480&height=640&seq=cover-xuanyi-03&orientation=portrait",
    status: "已完结", tags: ["时间", "平行世界", "悬疑"], views: 41200, chapters: 72, latestChapter: "已完结", updateTime: "完结", intro: "一枚能拨动时间的怀表，让主角在平行时空中不断穿梭。每一次改变过去都会引发新的谜团，结局反转令人拍案叫绝。",
  },
  {
    id: "c-gaoxiao-01", title: "废柴打工人", categoryId: "gaoxiao", author: "摸鱼大师", rating: 8.9,
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20lazy%20office%20worker%20with%20a%20comedic%20exaggerated%20expression%20at%20a%20warm%20desk%2C%20cheerful%20funny%20mood%2C%20comic%20art&width=480&height=640&seq=cover-gaoxiao-01&orientation=portrait",
    status: "连载中", tags: ["职场", "吐槽", "搞笑"], views: 96800, chapters: 180, latestChapter: "第180话 · 摸鱼日常", updateTime: "今日更新", intro: "当代打工人的真实写照！废柴青年王二狗在职场花式摸鱼、极限划水，每一格都是打工人的心声，笑到喷饭又莫名扎心。",
  },
  {
    id: "c-gaoxiao-02", title: "猫咪咖啡店", categoryId: "gaoxiao", author: "奶猫控", rating: 9.0,
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20cute%20cat%20and%20a%20barista%20in%20a%20warm%20cozy%20cafe%2C%20pastel%20warm%20tones%2C%20adorable%20healing%20mood%2C%20comic%20art&width=480&height=640&seq=cover-gaoxiao-02&orientation=portrait",
    status: "连载中", tags: ["猫咪", "治愈", "萌系"], views: 105000, chapters: 110, latestChapter: "第110话 · 新猫到店", updateTime: "昨日更新", intro: "一家塞满猫咪的治愈咖啡店，店长与一群性格迥异的猫主子斗智斗勇。软萌画风 + 爆笑日常，看完满血复活、治愈力满分。",
  },
  {
    id: "c-kehuan-01", title: "星海旅人", categoryId: "kehuan", author: "银河邮差", rating: 9.1,
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20space%20traveler%20gazing%20at%20a%20nebula%2C%20warm%20starlight%2C%20sci-fi%20adventure%2C%20cinematic%20warm%20tones%2C%20comic%20art&width=480&height=640&seq=cover-kehuan-01&orientation=portrait",
    status: "连载中", tags: ["星际", "冒险", "太空歌剧"], views: 76400, chapters: 98, latestChapter: "第98话 · 星之彼岸", updateTime: "2天前更新", intro: "独行旅人驾驶旧飞船穿越星海，在浩瀚宇宙中寻找失落家园。宏大的世界观、浪漫的太空歌剧，配以壮阔的星云画面，令人神往。",
  },
  {
    id: "c-kehuan-02", title: "机甲少年", categoryId: "kehuan", author: "铁拳轰鸣", rating: 8.6,
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20young%20pilot%20standing%20beside%20a%20warm-toned%20mecha%20robot%20in%20a%20sci-fi%20hangar%2C%20golden%20light%2C%20vibrant%20comic%20art&width=480&height=640&seq=cover-kehuan-02&orientation=portrait",
    status: "连载中", tags: ["机甲", "热血", "未来战争"], views: 61900, chapters: 86, latestChapter: "第86话 · 起航", updateTime: "4天前更新", intro: "少年天才驾驶员与他的伙伴机甲，在星际战场中浴血成长。钢铁与热血齐飞，机战打斗酣畅淋漓，未来感十足。",
  },
];

// 文章（书评/讨论）
export type Article = {
  id: string;
  title: string;
  categoryId: string;
  comicRef: string;
  cover: string;
  author: string;
  authorTitle: string;
  date: string;
  excerpt: string;
  views: number;
  likes: number;
  comments: number;
  tags: string[];
  paragraphs: string[];
};

export const articles: Article[] = [
  {
    id: "a-01", title: "《九霄仙途》深度书评：这才是东方仙侠该有的样子", categoryId: "xuanhuan", comicRef: "九霄仙途",
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20an%20immortal%20swordsman%20flying%20with%20a%20glowing%20sword%20among%20clouds%20and%20mountains%2C%20xianxia%20fantasy%2C%20warm%20gold%20and%20jade%20tones%2C%20epic%2C%20comic%20art&width=480&height=640&seq=cover-xuanhuan-01&orientation=portrait",
    author: "清霜道长", authorTitle: "资深书评人", date: "2026-08-10", excerpt: "修炼体系严谨、意境飘逸大气，从境界设定到打斗分镜都堪称教科书级别。",
    views: 32800, likes: 2100, comments: 486, tags: ["书评", "玄幻", "深度解析"],
    paragraphs: [
      "《九霄仙途》之所以能在众多仙侠漫画中脱颖而出，第一靠的便是严谨自洽的修炼体系。作者没有堆砌空洞的境界名词，而是把「练气—筑基—金丹—元婴—化神」的每一重都落实到具体的心境与场景之中，让读者能真切感受到主角每一次突破背后的积累与代价。",
      "其次是意境的分镜表达。御剑飞仙、云海翻涌、剑光纵横——这些本属文学意象的画面，被作者用大开大合的跨页与留白勾勒得仙气十足。没有花哨的滤镜堆砌，仅凭笔触与构图便营造出「一览众山小」的东方美学。",
      "更难能可贵的是人物塑造。主角不是一路顺风顺水的爽文模板，而是背负凡尘执念、在道与情之间反复挣扎的凡人。这种「人味」让整部作品在热血之上多了一层余味，也是它口碑持续走高的重要原因。",
      "当然，作品在中期节奏上偶有拖沓，部分支线略显冗余。但瑕不掩瑜，作为当下最值得追更的东方仙侠代表作，我依然愿意给出高分。强烈推荐给喜欢仙侠、武侠与热血成长题材的读者。",
    ],
  },
  {
    id: "a-02", title: "《樱花恋语》安利：每一格都甜到心坎里的纯爱之作", categoryId: "lianai", comicRef: "樱花恋语",
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20shy%20high%20school%20girl%20standing%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20and%20warm%20tones%2C%20gentle%20romantic%20mood%2C%20simple%20background%2C%20anime%20art&width=480&height=640&seq=cover-lianai-01&orientation=portrait",
    author: "四月小漫", authorTitle: "恋爱番剧迷", date: "2026-08-12", excerpt: "画风唯美、情感细腻，把青春暗恋的小心思刻画得淋漓尽致，越看越上头。",
    views: 28600, likes: 1880, comments: 392, tags: ["安利", "恋爱", "纯爱"],
    paragraphs: [
      "如果你正在寻找一部能让你会心一笑又微微鼻酸的纯爱漫画，《樱花恋语》一定不要错过。它没有狗血的三角恋，也没有刻意制造的误会，有的只是少年少女之间最纯粹、最笨拙的心动。",
      "作者对「暗恋」情绪的捕捉堪称精准。一个偷瞄的眼神、一次擦肩而过的紧张、一段欲言又止的对话——这些被无数人忽略的微小瞬间，都被作者用细腻的分镜放大，让人仿佛回到自己青涩的校园时代。",
      "画风方面，粉色的樱花、柔和的阳光与温暖的色调相得益彰，每一格都像是一张值得收藏的壁纸。尤其是主角在樱花树下回眸的那一格，直接封神。",
      "目前连载已进入情感升华阶段，发糖频率肉眼可见地提升。对于喜欢校园纯爱、治愈系作品的读者而言，这部绝对是近期不容错过的宝藏。",
    ],
  },
  {
    id: "a-03", title: "《雾都侦探》推理向书评：那些被忽略的伏笔大盘点", categoryId: "xuanyi", comicRef: "雾都侦探",
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20trench%20coat%20detective%20standing%20under%20a%20street%20lamp%20in%20fog%2C%20mystery%20noir%20mood%2C%20warm%20amber%20and%20brown%20tones%2C%20comic%20art&width=480&height=640&seq=cover-xuanyi-01&orientation=portrait",
    author: "迷雾推手", authorTitle: "推理爱好者", date: "2026-08-08", excerpt: "二刷之后才发现，原来真相早就藏在第一话的某个角落。伏笔回收堪称精妙。",
    views: 24700, likes: 1650, comments: 358, tags: ["书评", "悬疑", "伏笔"],
    paragraphs: [
      "追到《雾都侦探》最新话之后，我忍不住回头二刷。这一刷不要紧，赫然发现作者埋下的伏笔之密集、回收之巧妙，远超我的预期。可以说，这部作品从头到尾都在「诚实」地给出线索，只看你有没有注意到。",
      "最让我惊艳的是第一话的雨夜场景。当时以为只是交代环境的背景板，二刷才发现画面角落里那枚被雨水冲刷的袖扣，正是第三十章案件的关键证物。这种「铺垫—回收」的闭环，正是优质推理作品应有的素养。",
      "角色的塑造也值得称道。落魄侦探老徐并非全知全能，也会被表象迷惑、也会犯错；天才助手小棠也不是无脑工具人，而有着属于自己的秘密。人物与案件交织，让推理不再只是冷冰冰的解谜游戏。",
      "如果你喜欢那种需要动脑、又能在揭晓时获得「原来如此」快感的作品，《雾都侦探》绝对不会让你失望。强烈建议追更之前先补完前作，伏笔体验会更完整。",
    ],
  },
  {
    id: "a-04", title: "《猫咪咖啡店》治愈推荐：看完压力直接清零", categoryId: "gaoxiao", comicRef: "猫咪咖啡店",
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20cute%20cat%20and%20a%20barista%20in%20a%20warm%20cozy%20cafe%2C%20pastel%20warm%20tones%2C%20adorable%20healing%20mood%2C%20comic%20art&width=480&height=640&seq=cover-gaoxiao-02&orientation=portrait",
    author: "软fufu", authorTitle: "治愈系读者", date: "2026-08-14", excerpt: "上班累了一天，打开这部漫画的瞬间，什么烦恼都烟消云散了。",
    views: 31900, likes: 2300, comments: 520, tags: ["推荐", "治愈", "萌系"],
    paragraphs: [
      "如果你的心情需要一点点糖分，《猫咪咖啡店》就是那杯恰到好处的热可可。这部漫画讲述了一位年轻店长与一群性格各异的猫主子在咖啡店里斗智斗勇的日常，画风软萌、节奏轻快，读起来毫无负担。",
      "作者最擅长的是把「猫」的神韵画到极致。傲娇的橘猫、粘人的布偶、高冷的三花……每一只猫都有自己的小脾气和小故事，让人忍不住截图收藏。配合暖色调的画风，整部作品就像冬日里的一缕阳光。",
      "更难得的是，作品在搞笑之余也藏着细腻的温度。店长与猫、与客人之间的互动，常常在不经意间戳中人心，让人会心一笑的同时又感到一丝温暖。这种「笑中带暖」的治愈感，正是它口碑极佳的原因。",
      "总而言之，这是一部适合在疲惫时随手翻开、看完满血复活的作品。无论你是不是猫奴，都会被它的软萌与温暖俘获。",
    ],
  },
  {
    id: "a-05", title: "《航海狂潮》群像解析：为什么这些伙伴让人念念不忘", categoryId: "reqiu", comicRef: "航海狂潮",
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20young%20pirate%20captain%20standing%20on%20a%20ship%20deck%20with%20a%20rising%20sun%2C%20ocean%20adventure%2C%20warm%20golden%20tones%2C%20simple%20background%2C%20vibrant%20comic%20art&width=480&height=640&seq=cover-reqiu-02&orientation=portrait",
    author: "帆上星辰", authorTitle: "热血漫爱好者", date: "2026-08-05", excerpt: "热血漫的灵魂从来不只是打斗，而是那群愿意把后背交给你的人。",
    views: 21300, likes: 1420, comments: 301, tags: ["书评", "热血", "群像"],
    paragraphs: [
      "《航海狂潮》之所以能成为近期热血漫的顶流，绝不仅仅因为它酣畅淋漓的海战与打斗。真正让读者念念不忘的，是那艘船上形形色色的伙伴——他们各有缺陷、各有执念，却在一次次并肩作战中成为彼此最坚实的后盾。",
      "船长诺亚的热血与担当自不必说，更让我感动的是那些看似边缘的角色。沉默寡言的瞭望手、贪财却重义的航海士、总在危急关头挺身而出的厨子……作者用大量细腻的日常互动，让每个伙伴都鲜活而立体。",
      "作品的群像魅力在于「信任」二字。他们并非没有分歧与争吵，但每当风暴来临，总会有人毫不犹豫地挡在同伴身前。这种「把后背交给你」的羁绊，正是热血漫最能打动人心的地方。",
      "海战分镜同样堪称一绝，风暴、炮火与巨浪交织，场面宏大而不凌乱。对于热爱冒险与热血群像的读者来说，这部作品值得长期追更。",
    ],
  },
  {
    id: "a-06", title: "《星海旅人》世界观科普：那片星海的浪漫与孤独", categoryId: "kehuan", comicRef: "星海旅人",
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20space%20traveler%20gazing%20at%20a%20nebula%2C%20warm%20starlight%2C%20sci-fi%20adventure%2C%20cinematic%20warm%20tones%2C%20comic%20art&width=480&height=640&seq=cover-kehuan-01&orientation=portrait",
    author: "星图旅人", authorTitle: "科幻迷", date: "2026-08-03", excerpt: "一部把宇宙的壮阔与个体的孤独结合得恰到好处的太空歌剧。",
    views: 19800, likes: 1260, comments: 275, tags: ["科普", "科幻", "世界观"],
    paragraphs: [
      "《星海旅人》最打动我的地方，在于它把「宇宙的壮阔」与「个体的孤独」这对看似矛盾的情绪，融合得恰到好处。主角驾驶着那艘旧飞船，在无垠星海中独行，每一次停靠都短暂而温暖，每一次启程又归于孤寂。",
      "作品的世界观构建相当扎实。星际航行的规则、各星系的文明设定、宇宙尺度的时间与距离，都被作者用严谨又浪漫的方式呈现，让人沉浸其中。作者没有急于堆砌设定，而是将世界观自然地融入每一次旅程。",
      "画面方面，星云、星系与飞船穿梭的镜头极具美感，暖色的星光是整部作品最鲜明的视觉标签。配合作者对「家园」这一主题的反复叩问，让这部科幻漫画多了几分诗意的底色。",
      "如果你喜欢宏大的世界观、浪漫的太空歌剧，以及对「孤独与归属」的深度思考，《星海旅人》绝对值得你登船一游。",
    ],
  },
  {
    id: "a-07", title: "《废柴打工人》吐槽：这一话简直在我工位上装了摄像头", categoryId: "gaoxiao", comicRef: "废柴打工人",
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20lazy%20office%20worker%20with%20a%20comedic%20exaggerated%20expression%20at%20a%20warm%20desk%2C%20cheerful%20funny%20mood%2C%20comic%20art&width=480&height=640&seq=cover-gaoxiao-01&orientation=portrait",
    author: "摸鱼快乐", authorTitle: "打工人代表", date: "2026-08-11", excerpt: "是谁在监视我的打工日常？每一格都笑到想哭，又真实得扎心。",
    views: 30500, likes: 2050, comments: 467, tags: ["吐槽", "职场", "搞笑"],
    paragraphs: [
      "如果说哪部漫画最能引起当代打工人的共鸣，《废柴打工人》绝对榜上有名。主角王二狗的花式摸鱼、极限划水，简直是把无数人的工位日常搬上了漫画——是谁在监视我的生活？",
      "最绝的是它对职场细节的精准拿捏。周一早高峰的绝望、例会上的假装认真、下午三点的困意袭来、周五下午的提前下班心切……每一格都真实到让人笑中带泪。笑点密集，吐槽犀利，堪称打工人的精神食粮。",
      "当然，作品并非只有搞笑。在喜剧的外壳下，作者也悄悄安放了打工人的辛酸与不易——加班后的疲惫、面对业绩压力的焦虑。这些藏在笑声背后的真实，让作品多了几分温度与厚度。",
      "总之，这是一部既能让你捧腹大笑、又能让你在笑完后感到「被理解」的作品。推荐给每一个在职场中摸爬滚打的你。",
    ],
  },
  {
    id: "a-08", title: "《镇魔令》初看指南：入坑之前你需要知道的几件事", categoryId: "xuanhuan", comicRef: "镇魔令",
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20young%20exorcist%20holding%20a%20talisman%20scroll%20with%20glowing%20seals%2C%20warm%20mystic%20tones%2C%20fantasy%20comic%20art&width=480&height=640&seq=cover-xuanhuan-03&orientation=portrait",
    author: "玄猫公子", authorTitle: "暗黑玄幻迷", date: "2026-08-09", excerpt: "画风黑暗张力十足，设定新意满满，入坑前先把这几件事弄明白。",
    views: 17200, likes: 980, comments: 214, tags: ["指南", "玄幻", "暗黑"],
    paragraphs: [
      "《镇魔令》是一部气质相当独特的玄幻漫画。它既有仙侠世界的光怪陆离，又带着一层挥之不去的暗黑氛围，画风张力十足。在入坑之前，有几件事我想先跟你聊聊。",
      "首先，这部作品的设定体系相当新颖。执令者、符箓、镇魔司等设定既有东方传统的底蕴，又被作者赋予了独特的诠释，读起来新鲜感十足。建议初读者放慢速度，慢慢感受作者构建的这套暗黑美学。",
      "其次，作品的整体基调偏暗，涉及牺牲、背叛与身世之谜等元素，并非适合所有人的轻松向作品。如果你偏爱有深度、带点暗黑气质的故事，那么《镇魔令》会很对你的胃口。",
      "最后，故事的伏笔埋得很深，主角玄夜的身世之谜贯穿始终，越往后越精彩。耐心追更，你会收获一个层层反转、意蕴悠长的好故事。",
    ],
  },
  {
    id: "a-09", title: "《同桌的心事》观后感：那些年我们没有说出口的喜欢", categoryId: "lianai", comicRef: "同桌的心事",
    cover: "https://readdy.ai/api/search-image?query=manga%20illustration%20of%20two%20high%20school%20classmates%20sitting%20at%20a%20desk%2C%20warm%20classroom%20light%2C%20romantic%20slice%20of%20life%2C%20soft%20warm%20tones%2C%20anime%20art&width=480&height=640&seq=cover-lianai-02&orientation=portrait",
    author: "青春存档", authorTitle: "校园漫迷", date: "2026-08-06", excerpt: "看这部漫画的时候，我总是不由自主想起自己的同桌，想起那些没说出口的话。",
    views: 22600, likes: 1580, comments: 342, tags: ["观后感", "校园", "青春"],
    paragraphs: [
      "《同桌的心事》大概是近两年最能让我产生共鸣的校园恋爱漫画了。它没有惊心动魄的情节，有的只是同桌之间那些藏在日常里的、细碎而真实的心动。",
      "看这部作品时，我总会不由自主地想起自己的学生时代。想起那个总借我橡皮的同桌，想起那些因为胆怯而终究没有说出口的喜欢。作者精准地捕捉到了青春里最隐秘、也最珍贵的那份悸动。",
      "最打动我的是作品对「日常」的刻画。传纸条、抢笔、晚自习时不经意的对视……这些看似平淡的瞬间，在作者的笔下都变得闪闪发光。原来最好的青春恋爱漫，从来都不需要夸张的情节。",
      "如果你也曾在青春里有过一段没说出口的心事，那么这部漫画一定会让你会心一笑，又微微鼻酸。推荐给所有怀念青春的人。",
    ],
  },
];

// 文章评论（粉丝圈子）
export type Comment = {
  id: string;
  userName: string;
  avatarText: string;
  avatarBg: string;
  time: string;
  content: string;
  likes: number;
  replies: number;
};

export const comments: Comment[] = [
  { id: "cm-1", userName: "追更狂魔小九", avatarText: "九", avatarBg: "bg-primary-500", time: "2小时前", content: "这篇书评写到我心坎里了！尤其是伏笔回收那一段，我二刷的时候也是这个感觉，作者真的太会埋线了。", likes: 128, replies: 12 },
  { id: "cm-2", userName: "清水煮雨", avatarText: "清", avatarBg: "bg-accent-500", time: "5小时前", content: "看完立刻去补了这部漫画，已经上头。感谢安利，评论区还有没有类似的推荐？在线等！", likes: 96, replies: 23 },
  { id: "cm-3", userName: "不会起名", avatarText: "名", avatarBg: "bg-secondary-500", time: "昨天", content: "楼主分析得很到位，不过我觉得主角中期的人设变化其实是有伏笔的，建议结合第30话再细品。", likes: 54, replies: 8 },
  { id: "cm-4", userName: "元气满满酱", avatarText: "元", avatarBg: "bg-primary-700", time: "昨天", content: "刚追完最新话，泪目。作者的处理方式比我预期的温柔多了，希望后面能一直甜下去！", likes: 203, replies: 31 },
];

// 首页 FAQ
export type FaqItem = { q: string; a: string };

export const faqs: FaqItem[] = [
  { q: "漫画岛是什么网站？", a: "漫画岛是一个面向漫画爱好者的同好讨论社区，聚合漫画评论区、粉丝圈子与书评交流。你可以在这里安利热门漫画、阅读深度书评、参与追更讨论，并找同好一起交流推荐。" },
  { q: "如何找到自己喜欢的漫画类型？", a: "你可以在分类页面按类型筛选，目前涵盖热血冒险、恋爱日常、玄幻仙侠、悬疑烧脑、搞笑治愈与科幻未来六大类型，点击即可浏览对应漫画与书评。" },
  { q: "可以参与评论和讨论吗？", a: "当然可以。每一篇书评和漫画详情下都有评论区与粉丝圈子，你可以发表观点、点赞互动，并与其他同好一起交流推荐。" },
  { q: "书评文章多久更新一次？", a: "我们的书评人团队会持续产出优质书评与安利内容，热门漫画更新当天通常就会有追更讨论与推荐上线，欢迎常来看看。" },
  { q: "如何在站内求推荐？", a: "你可以在评论区或粉丝圈子发布你的偏好与需求，其他同好和书评人都会热心为你推荐合适的漫画。" },
];